import { RealtimeRole } from '@doxyme/realtime';
import { storage } from '@doxyme/ui/utils';

import { clearLoggerContext } from '../../libs/logger';
import { redirectTo } from '../routerUtils';
import type { ApolloSession } from '../../features/apolloSession/apolloSession.types';

const DEFAULT_LEAVE_URL = '/account/dashboard';

export const getRedirectUrl = (
  referrer: string,
  hasSurvey: boolean,
): string => {
  const basePath = referrer || DEFAULT_LEAVE_URL;
  const searchParams = new URLSearchParams();

  if (hasSurvey) {
    searchParams.append('survey', 'true');
  }

  const search = searchParams.toString();
  return search ? `${basePath}?${search}` : basePath;
};

export const redirect = (referrer: string, hasSurvey = true): void => {
  clearLoggerContext();

  // Backward compatibility solution for OG testing
  const alwaysShowSurvey = Boolean(
    storage.getItem<boolean>('testing-always-show-survey'),
  );
  redirectTo(getRedirectUrl(referrer, alwaysShowSurvey || hasSurvey));
};

/**
 * Checking if we have at least role defined in apollo session,
 * if not, that means it was some incorrect navigation to apollo page
 */
export const shouldRedirectWithoutSurvey = ({ role }: ApolloSession): boolean =>
  !role;

/**
 * Checking if we have all required data in apollo session to start a call
 */
export const shouldRedirectWithSurvey = ({
  role,
  patientId,
  sessionId,
}: ApolloSession): boolean =>
  Boolean(role) &&
  ((role === RealtimeRole.Provider && patientId === undefined) ||
    (role === RealtimeRole.Patient && sessionId === undefined));
